export default "__VITE_ASSET__BrFCKyid__"